export default __webpack_public_path__ + "static/media/feather.f7b5b187.svg";